module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGUAAAADCAYAAACK0cGIAAAABGdBTUEAALGPC/xhBQAAAEhJREFUOBHtkcENADAIAjXpYG7W1dzMQlNGaPxIchF5gldVmBmh0t1zsr4OOMICATaQEibAZD0d3FE4gpTP6PKV152MDfzrxQ63vp/2Suf1cwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/img/share/cxx.png
// module id = 372
// module chunks = 0